import classNames from "classnames";
import { VisuallyHidden } from "react-aria";
import {
    Modal as BaseModal,
    Button,
    Dialog,
    ModalOverlay,
    composeRenderProps,
} from "react-aria-components";

import CloseIcon from "../../public/svg/x.svg";

import styles from "./modal.module.scss";

export type Props = Omit<React.ComponentProps<typeof BaseModal>, "children"> &
    Pick<React.ComponentProps<typeof Dialog>, "children" | "role"> & {
        /** We use a 12-column layout for designs; these correspond to 12, 8, and 6 columns */
        width?: "full" | "twoThirds" | "half";
        /**
         * We use a 12-column layout for designs; "column" uses one column for padding-left
         * and one for padding-right
         */
        padding?: "column" | "minimal";
    };

export const Modal = ({
    children,
    className,
    role,
    width = "half",
    padding = "column",
    ...props
}: Props) => (
    <ModalOverlay {...props} isDismissable className={styles.overlay}>
        <BaseModal className={styles.modal}>
            <Dialog
                className={classNames([
                    styles[width],
                    styles[`${padding}Padding`],
                    className,
                ])}
                role={role}
            >
                {composeRenderProps(children, (children) => (
                    <>
                        <Button slot="close" className={styles.close}>
                            <CloseIcon />
                            <VisuallyHidden>Close Modal</VisuallyHidden>
                        </Button>
                        <div>{children}</div>
                    </>
                ))}
            </Dialog>
        </BaseModal>
    </ModalOverlay>
);
